// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__NhKkk","info":"Note_info__GXnw3","note":"Note_note__3hZYY","actions":"Note_actions__2B0DG"};